<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 28.426 51">
      <g id="Group_27748" data-name="Group 27748" transform="translate(0.207 0)">
        <g id="Group_27750" data-name="Group 27750">
          <path id="Path_86967" data-name="Path 86967" d="M.5,5.992a19.192,19.192,0,0,1,27.012.131" fill="none"
            :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          <path id="Path_86968" data-name="Path 86968" d="M5.409,11.1c4.15-4.55,12.338-4.939,17.052-.1" fill="none"
            :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          <path id="Path_86969" data-name="Path 86969" d="M10.416,16.059c1.5-1.944,5.1-2,7.116-.036" fill="none"
            :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          <path id="Path_86970" data-name="Path 86970" d="M23.265,35.173a9.259,9.259,0,0,1-18.518,0" fill="none"
            :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          <line id="Line_1934" data-name="Line 1934" y2="5.609" transform="translate(14.006 44.891)" fill="none"
            :stroke="themeColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1" />
          <path id="Path_86971" data-name="Path 86971"
            d="M14.006,38.79h0A4.036,4.036,0,0,1,9.97,34.754V25.071a4.036,4.036,0,0,1,8.072,0v9.683A4.036,4.036,0,0,1,14.006,38.79Z"
            fill="none" :stroke="themeColor" stroke-miterlimit="10" stroke-width="1" />
        </g>
      </g>
    </svg>
  </div>
</template>
<script>
import { useChatSettingsStore } from '../../../store/ChatSettingsStore/ChatSettingsStore';
import { mapWritableState } from 'pinia';

export default {
  props: {
    themeColor: {
      type: String,
      required: false,
      default: '#000',
    },
    isHoverUser: {
      type: Boolean,
      required: false,
      default: false,
    },
    height: {
      type: String,
      required: false,
      default: '30px',
    },
    width: {
      type: String,
      required: false,
      default: '30px',
    },
  },
  data() {
    return {
      themePrimaryColor: window.primaryColor,
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
  },
}
</script>
